export var ebookTranslations = {
    "": { id: "ui-br-publishers.publishers.select.label.default" },
    PDF: {
        id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.pdf",
    },
    EPUB: {
        id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.epub",
    },
    MOBI: {
        id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.mobi",
    },
    pdf: {
        id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.pdf",
    },
    epub: {
        id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.epub",
    },
    mobi: {
        id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.mobi",
    },
    OTHER: {
        id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.other",
    },
};
export var getEbookTranslations = function (intl, key) {
    var translation = ebookTranslations[key];
    if (!translation)
        return key;
    return intl.formatMessage(translation);
};
